import * as types from "../actions/actionTypes";
import initialState from "./initialState";
import { insertItem, removeItem } from "./helpers";

export default function invitationsReducer(
  state = initialState.invitations,
  action
) {
  switch (action.type) {
    case types.SEND_INVITATION_SUCCESS:
      return {
        pagination: state.pagination,
        results: insertItem(state.results, action.invitation),
      };
    case types.LOAD_INVITATIONS_SUCCESS:
      return {
        pagination: action.meta,
        results: action.invitations,
      };
    case types.DELETE_INVITATION_SUCCESS:
      return {
        pagination: state.pagination,
        results: removeItem(state.results, action.invitation),
      };
    default:
      return state;
  }
}
